import playlistApp from '@app2/modules/Library/Builder/playlist.app'

const namespaced = true;

const state = {
  showModal: true,
  playlist: {
    title: '',
    description: '',
    sort: 'position',
    created_at: null
  },
  playlistMultiple: false,
  selectedFolders: [],
  selectModel: null,
  folderQuery: {
    list: [],
    page: 1,
    total: 0,
    lastPage: 1
  },
  playlistFormBackRoute: null,
  isPlaylistModalOpen: false,
  routeParams: {},
  backRouteMediaHash: null,
  featuredFileTargetHash: null,
  editBlocksMode: false,
  fileToSchedule: null,
  playlistToSchedule: null,
};

const mutations = {
  TOGGLE_MODAL(state, payload) {
    state.showModal = payload
  },
  SET_PLAYLIST(state, payload) {
    state.playlist = payload
  },
  SET_SELECT_MODEL(state, payload) {
    state.selectModel = payload
  },
  SET_FILE_TO_SCHEDULE(state, payload) {
    state.fileToSchedule = payload
  },
  SET_PLAYLIST_TO_SCHEDULE(state, payload) {
    state.playlistToSchedule = payload
  },
  SET_PLAYLIST_MULTIPLE(state, payload) {
    state.playlistMultiple = payload
  },
  SET_SELECTED_FOLDERS(state, payload) {
    state.selectedFolders = payload
  },
  SET_PLAYLIST_FORM_BACK_ROUTE(state, payload) {
    state.playlistFormBackRoute = payload
  },
  SET_ROUTE_PARAMS(state, payload) {
    state.routeParams = payload
  },
  SET_BACK_ROUTE_MEDIA_HASH(state, payload) {
    state.backRouteMediaHash = payload
  },
  SET_IS_PLAYLIST_MODAL_OPEN(state, payload) {
    state.isPlaylistModalOpen = payload
  },
  SET_FEATURED_FILE_TARGET_HASH(state, payload) {
    state.featuredFileTargetHash = payload
  },
  SET_EDIT_BLOCKS_MODE(state, payload) {
    state.editBlocksMode = payload
  },
};

const actions = {
  resetPlaylist({ commit }) {
    commit('SET_PLAYLIST', {
      title: '',
      description: '',
      sort: 'position',
      created_at: null
    })
  },
  closeDialog({ commit }) {
    commit('SET_PLAYLIST', null)
    commit('SET_SELECT_MODEL', null)
    playlistApp.$bvModal.hide('playlist-form-dialog');
  },
  setPlaylist({ commit }, payload) {
    commit('SET_SELECT_MODEL', null)
    commit('SET_PLAYLIST', payload)
  },
  setSelectModel({ commit }, payload) {
    commit('SET_SELECT_MODEL', payload)
  },
  setSelectedFolders({ commit }, payload) {
    commit('SET_SELECTED_FOLDERS', payload)
  },
  setBackRouteMediaHash({ commit }, payload) {
    commit('SET_BACK_ROUTE_MEDIA_HASH', payload)
  },
  setFeaturedFileTargetHash({ commit }, payload) {
    commit('SET_FEATURED_FILE_TARGET_HASH', payload)
  },
  setEditBlocksMode({ commit }, payload) {
    commit('SET_EDIT_BLOCKS_MODE', payload)
  },
};

const getters = {
  GET_BACK_ROUTE_MEDIA_HASH: state => state.backRouteMediaHash,
  GET_IS_PLAYLIST_MODAL_OPEN: state => state.isPlaylistModalOpen,
  GET_FEATURED_FILE_TARGET_HASH: state => state.featuredFileTargetHash,
  GET_EDIT_BLOCKS_MODE: state => state.editBlocksMode,
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters
};
